import { rankings } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-100 scroll-mt-16">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-600 bg-primary-100 rounded-full mb-3">热度榜单</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热门排行</h2>
          <p className="mt-2 text-foreground-600 text-sm">基于阅读量与讨论热度的实时榜单</p>
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden">
          {rankings.map((item, idx) => (
            <a
              key={item.id}
              href="#"
              className={`flex items-center gap-4 px-5 py-4 hover:bg-background-50 transition-colors cursor-pointer ${
                idx < rankings.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div className={`w-9 h-9 flex items-center justify-center rounded-lg flex-shrink-0 ${
                idx === 0 ? 'bg-primary-500 text-background-50' :
                idx === 1 ? 'bg-accent-500 text-background-50' :
                idx === 2 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-500'
              }`}>
                <span className="text-sm font-bold">{idx + 1}</span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-sm font-medium text-foreground-900 truncate">{item.title}</span>
                  {item.hot && (
                    <span className="px-1.5 py-0.5 text-[10px] font-medium bg-primary-100 text-primary-600 rounded-full flex items-center gap-0.5">
                      <i className="ri-fire-line text-[9px]"></i>热
                    </span>
                  )}
                </div>
                <span className="text-xs text-foreground-500 mt-0.5 inline-block">{item.tag}</span>
              </div>
              <div className="flex items-center gap-1 text-xs text-foreground-500 flex-shrink-0">
                <i className="ri-eye-line"></i>
                <span>{item.views}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}